const tab_sections = {
    overview: "Vue d'ensemble",
    resource_management: 'Gestion des ressources',
    user_management: 'Gestion des utilisateurs',
    help_and_support: 'Aide et support',
};
export default tab_sections;
